import { apiLogin, apiLogout, addBehavior } from '@/api/user/login'
import {
  submitAnswerPaperRecord,
} from "@/api/answer/answer";
import { paperGetToken } from "@/api/index/index";
import { apiGetUserInfo } from '@/api/user/profile'
import { getToken, setToken, removeToken,getBrowserToken } from '@/utils/auth'
import { leafletApiURL,leafletApiURLV3 } from '@/utils/config'
import storage from '@/utils/cache'
let { local: localCache } = storage
let threeUserInfo=getBrowserToken()||"{}"
const persistAvatar = localCache.get('AVATAR') || require('@/assets/images/default-avatar.jpg')
const persistUserName = localCache.get('USERNAME') || '神秘人'
const persistUserId = localCache.get('USERID')||JSON.parse(threeUserInfo).userId || ''
const persisttestPaperId = localCache.get('testPaperId') || ''
const persistnickName = localCache.get('USERNAMENICK')||JSON.parse(threeUserInfo).userName || ''
const threePlatform = JSON.parse(threeUserInfo).platform || ''
const persistPARAMDATA = localCache.get('PARAMDATA') || ''
const isYuShuYuanUser = localCache.get('USERID')?true:false

const user = {
    state: {
        token: getToken(),
        name: persistUserName,
        avatar: persistAvatar,
        userId: persistUserId,
        testPaperId: persisttestPaperId,
        userName: persistnickName,
        paramsdata:persistPARAMDATA,
        isYuShuYuanUser:isYuShuYuanUser,
        threePlatform:threePlatform,
        leafletApiURL:leafletApiURL,
        myGoodsNum: 0,
        mySubjectNum: 0,
        myBundleNum: 0,
        paperType: [{
            questionType: '1',
            name: '单选题'
        },
        {
            questionType: '2',
            name: '多选题'
        },
        {
            questionType: '3',
            name: '判断题'
        },
        {
            questionType: '4',
            name: '听力单选'
        }, {
            questionType: '5',
            name: '听力多选'
        }, {
            questionType: '6',
            name: '连线题'
        }, {
            questionType: '7',
            name: '排序题'
        }, {
            questionType: '8',
            name: '音/视频'
        }, {
            questionType: '9',
            name: '跟读题'
        }, {
            questionType: '10',
            name: '填空题'
        }, {
            questionType: '11',
            name: '听力填空题'
        }, {
            questionType: '12',
            name: '选词填空题'
        }, {
            questionType: '13',
            name: '简答题'
        }, {
            questionType: '14',
            name: '题组'
        }, {
            questionType: '15',
            name: '听力题组'
        }, {
            questionType: '16',
            name: '完形填空题'
        }, {
            questionType: '17',
            name: '名词解释'
        }, {
            questionType: '18',
            name: '论述题'
        }, {
            questionType: '19',
            name: '计算题'
        }, {
            questionType: '20',
            name: '案例分析题'
        }, {
            questionType: '21',
            name: '阅读题'
        }, {
            questionType: '22',
            name: '翻译题'
        }
        ],
        judgeRightOrWrong: ['0', '1', '2', '3', '4', '5', "6", "7", "10", "11", "12", "14", "15", "16"],
    },

    mutations: {
        SET_params: (state, params) => { 
            if (params) {
                state.paramsdata = params
                localCache.set('PARAMDATA', JSON.stringify(params))
            } else { 
                state.paramsdata = ''
                localCache.set('PARAMDATA', '')
            }
        },
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
            localCache.set('USERNAME', name)
        },
        SET_USERID: (state, userId) => {
            state.userId = userId
            localCache.set('USERID', userId)
        },
        SET_USERNAME: (state, userName) => {
            state.userName = userName
            localCache.set('USERNAMENICK', userName)
        },
        SET_AVATAR: (state, avatar) => {
            state.avatar = avatar
            localCache.set('AVATAR', avatar)
        },
        SET_MYGOODSNUM: (state, num) => {
            state.myGoodsNum = num
        },
        SET_MYSUBJECTNUM: (state, num) => {
            state.mySubjectNum = num
        },
        SET_MYBUNDLENUM: (state, num) => {
            state.myBundleNum = num
        },
        // 修改调用数字教材v3接口还是v2接口
        SET_LEAFLET_API_URL: (state, version) => {
            console.log('ddddddddddddddddddddddddd',version);
            
            if(version=='v3'){
                state.leafletApiURL = leafletApiURLV3
            }else{
                state.leafletApiURL = leafletApiURL
            }
            console.log('state.leafletApiURL===============',state.leafletApiURL);
            
        },
        SET_testPaperId: (state, id) => {
            state.testPaperId = id
            localCache.set('testPaperId', id)
        },

    },

    actions: {
        //提交试卷
        submitAnswerPaper( { commit,state }) { 
            if (state.paramsdata != "") {
            let data = JSON.parse(state.paramsdata)
            if(data.type!='关闭') return
            paperGetToken().then((token) => {
            data.token=token.data
            submitAnswerPaperRecord(data);
            commit('SET_params','')
            });
            }
        },
        // 登录
        Login({ commit, dispatch }, data) {
            let { type, params } = data
            return new Promise((resolve, reject) => {
                apiLogin(type, params)
                    .then((res) => {
                        let { access_token, expires_in } = res.data
                        setToken(access_token)
                        commit('SET_TOKEN', access_token)
                        dispatch('addUserActivation')
                        dispatch('GetUserInfo').then(() => dispatch('GetShoppingCart').then(() => resolve()))
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        //app登录
        appLogin({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                let access_token = data
                setToken(access_token)
                commit('SET_TOKEN', access_token)
                dispatch('GetUserInfo').then(() => dispatch('GetShoppingCart').then(() => resolve())).catch((error) => {
                    reject(error)
                })
            })
        },
        // 获取用户信息
        GetUserInfo({ commit, state }) {
            return new Promise((resolve, reject) => {
                apiGetUserInfo()
                    .then((res) => {
                        const userInfo = res.data || {}
                        let nickName = userInfo.truename || '神秘人'
                        let avatar = userInfo.avatar || require('@/assets/images/default-avatar.jpg')
                        let userId = userInfo.frontUserId || ''
                        let userName = userInfo.frontUserName || ''
                        commit('SET_NAME', nickName)
                        commit('SET_AVATAR', avatar)
                        commit('SET_USERID', userId)
                        commit('SET_USERNAME', userName)
                        resolve(userInfo)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        // 退出系统
        LogOut({ commit }) {
            return new Promise((resolve, reject) => {
                apiLogout()
                    .then(() => {
                        commit('SET_TOKEN', '')
                        commit('SET_NAME', '')
                        commit('SET_AVATAR', '')
                        commit('SET_USERID', '')
                        commit('setShoppingCart', [])
                        commit('SET_MYGOODSNUM', 0)
                        commit('SET_MYSUBJECTNUM', 0)
                        commit('SET_MYBUNDLENUM', 0)
                        removeToken()
                        resolve()
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },

        // 前端 登出
        FedLogOut({ commit }) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                commit('SET_NAME', '')
                commit('SET_AVATAR', '')
                commit('SET_USERID', '')
                commit('setShoppingCart', [])
                commit('SET_MYGOODSNUM', 0)
                commit('SET_MYSUBJECTNUM', 0)
                commit('SET_MYBUNDLENUM', 0)
                removeToken()
                resolve()
            })
        },
        /**
         * 添加用户活跃度
         * 获取当前时间零点时间戳存到缓存，如果当前时间戳大于缓存中的时间戳，
         * 证明距离上次添加活跃度的时间大于一天
         */
        addUserActivation() {
            let NowTime = new Date(new Date().toLocaleDateString()).getTime()
            let LastUpdateTime = localStorage.getItem('LastUpdateTime')
            if (LastUpdateTime && (NowTime - Number(LastUpdateTime)) > 0) {
                addBehavior()
                localStorage.setItem('LastUpdateTime', NowTime)
            } else if (!LastUpdateTime) {
                addBehavior()
                localStorage.setItem('LastUpdateTime', NowTime)
            }
        }
    },
}

export default user